import React, { useEffect, useState } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { isNative, setCookie } from 'srcReact/helpers/utils'
import queryString from 'query-string'
import { useDispatch } from 'react-redux'
import { loginActions } from 'srcReact/LoginPage'

export const PrivateRoute = ({ component: Component, redirectUrl, queryParam, ...rest }) => {
  const dispatch = useDispatch()
  const [urlToRedirect, setUrlToRedirect] = useState('')
  let ssoParams = queryString.parse(rest.location.search)
  let pathname = rest.location.pathname

  useEffect(() => {
    if (ssoParams && ssoParams.orig) {
      //if url contains SSO parameters, do the login in mixr with SSO credentials
      //if browser has already session cookie, then logout and relogin to avoid any dirty token
      let orgId = 0
      //location storage values are set during org selection screen on login pages. Remove them once they served their purpose.
      if (localStorage.getItem('ssoOrgId') !== null) {
        orgId = parseInt(localStorage.getItem('ssoOrgId'))
        setCookie('current_organization_id', orgId)
      }
      if (isUserAuthorized()) {
        dispatch(loginActions.userLogout(localStorage.getItem('ssoEmail'), ssoParams.sso_key, orgId))
      } else {
        dispatch(loginActions.login(localStorage.getItem('ssoEmail'), ssoParams.sso_key, orgId, 'sso', false))
      }
      localStorage.removeItem('ssoEmail')
      setUrlToRedirect('')
    } else {
      setUrlToRedirect(
        //redirectUrl ? redirectUrl : pathname ? `/auth/?ruaa=${encodeURI(config.webUrl + pathname)}` : `/auth`
        redirectUrl ? redirectUrl : `/auth`
      )
    }
  }, [])

  return (
    <Route
      {...rest}
      render={(props) => {
        if (urlToRedirect.includes('community.mixr.net') && !isUserAuthorized() && urlToRedirect) {
          window.location = urlToRedirect
          return null
        } else if (pathname.includes('/0/workplaces') && isUserAuthorized() && urlToRedirect) {
          window.location.assign(urlToRedirect)
          return null
        }
        return (isUserAuthorized() || isNative()) && Component ? (
          <Component {...props} />
        ) : (
          urlToRedirect && (
            <Redirect
              to={{
                pathname: urlToRedirect,
                state: {
                  from: props.location,
                  queryParam: queryParam ? queryParam : ''
                }
              }}
            />
          )
        )
      }}
    />
  )
}
